import LogOutUser from "services/LogOutUser";
import { loggedUserPages, PageType } from "types/PageI";

/** headr loaded events */
const headerLoadedEventCallback = (e, dispatchPage) => {
    // console.log("headerLoadedEventCallback");
    // console.log(e);
    dispatchPage({
        type: "header_loaded"
    })
}
export const addHeaderLoadedListener = (dispatchPage) => {
    window.addEventListener("xf_header_loaded", e => headerLoadedEventCallback(e, dispatchPage));  
}

export const removeHeaderLoadedListener = (dispatchPage) => {
    window.removeEventListener("xf_header_loaded", e => headerLoadedEventCallback(e, dispatchPage))
}

/** User change Events */
export const triggerUserEvent = () => {
    // console.log('trigger User Event'.toUpperCase());
    
    const event = new Event("xf_user_change");
    window.dispatchEvent(event);
}

/** page change event */
const pageEventCallback = (e, dispatchPage) => {
    // console.log(e);
    // console.log("page Event Callback".toUpperCase());

    // return 
    if ("xf_active_page" in sessionStorage) {
        let active_page = sessionStorage.getItem("xf_active_page") || ""
        // console.log("active page".toUpperCase(), active_page);
        let type = JSON.parse(active_page  || PageType.entrance) as PageType

        if (!("xf_active_user" in sessionStorage) && loggedUserPages.includes(type)) {
            type = PageType.entrance
        }

        dispatchPage({
            type: "render",
            payload: {
                page: type
            }
        })
    }
}
export const addPageListener = (dispatchPage) => {
    window.addEventListener('xf_page_change', e => pageEventCallback(e, dispatchPage))
}
export const removePageListener = (dispatchPage) => {
    window.removeEventListener('xf_page_change', e => pageEventCallback(e, dispatchPage))

}

const userLogoutEventCallback = async (e, user, dispatchUser, dispatchPage) => {
    // console.log('user Logout Event Callback'.toUpperCase());
    // let logout = await LogOutUser(user.client_id, user.connection_id)
    // console.log(logout);
    
    dispatchUser({type: "log_out", payload: ''})       
    dispatchPage({type: "log_out", payload: PageType.entrance})       

}
export const addUserLogoutListener = (user, dispatchUser, dispatchPage) => {
    window.addEventListener('xf_user_logout', e => userLogoutEventCallback(e, user, dispatchUser, dispatchPage))
}
export const removeUserLogoutListener = (user, dispatchUser, dispatchPage) => {
    window.removeEventListener('xf_user_logout', e => userLogoutEventCallback(e, user, dispatchUser, dispatchPage))
}